"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pile = void 0;
class Pile {
    get hasCards() {
        return this.cards.length > 0;
    }
    get cardCount() {
        return this.cards.length;
    }
    get lastCard() {
        return this.cards.length > 0
            ? this.cards[this.cards.length - 1]
            : undefined;
    }
    get allCards() {
        return this.cards;
    }
    constructor(pileId) {
        this.cards = [];
        this.id = pileId;
    }
    clone() {
        const newPile = new Pile(this.id);
        newPile.cards = this.cards.map((card) => card.clone());
        return newPile;
    }
    getCardByCardId(cardId) {
        return this.cards.find((card) => { var _a; return ((_a = card.cardId) === null || _a === void 0 ? void 0 : _a.id) === cardId; });
    }
    getCardByCardIndex(index) {
        return this.cards.find((card) => card.index === index);
    }
    containsCardId(cardId) {
        return this.cards.some((card) => { var _a; return ((_a = card.cardId) === null || _a === void 0 ? void 0 : _a.id) === cardId; });
    }
    containsCardIndex(index) {
        return this.cards.some((card) => card.index === index);
    }
    parentCard(childCard) {
        const indexOfChild = this.cards.indexOf(childCard);
        if (indexOfChild <= 0) {
            return undefined;
        }
        const parentIndex = indexOfChild - 1;
        return this.cards[parentIndex];
    }
    addCard(card) {
        this.cards.push(card);
    }
    removeCard(card) {
        const foundIndex = this.cards.findIndex((item) => item === card);
        if (foundIndex !== -1) {
            this.cards.splice(foundIndex, 1);
        }
    }
    removeAllCards() {
        this.cards.length = 0;
    }
    moveCards(card) {
        const cardsToMove = [];
        const cardIndex = this.cards.findIndex((item) => item === card);
        if (cardIndex === -1) {
            return cardsToMove;
        }
        for (let index = cardIndex; index < this.cardCount; ++index) {
            cardsToMove.push(this.cards[index]);
        }
        return cardsToMove;
    }
    combine(cards) {
        cards.push(...this.cards);
    }
}
exports.Pile = Pile;
